import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  selectNotificationInbox,
  selectStudyAttention,
} from '@app/generated/feature-flags.selectors';

/**
 * `/attention/:id` (a reconciliation question's conversation, #3944) exists only while `studyAttention` and its dependency
 * `notificationInbox` are both on (notifications restart L6). Otherwise the URL falls through to not-found, as before the
 * route existed; saved conversations are untouched and come back when both flags are on. `studyAttention` is
 * deployment-managed until private conversations land (L7).
 */
export const studyAttentionCanMatch: CanMatchFn = () => {
  const store = inject(Store);
  return (
    store.selectSignal(selectNotificationInbox)() &&
    store.selectSignal(selectStudyAttention)()
  );
};
